import { render, staticRenderFns } from "./ticket-type.vue?vue&type=template&id=99e707f6&scoped=true&"
import script from "./ticket-type.vue?vue&type=script&lang=js&"
export * from "./ticket-type.vue?vue&type=script&lang=js&"
import style0 from "./ticket-type.vue?vue&type=style&index=0&id=99e707f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99e707f6",
  null
  
)

export default component.exports